<div class="box">
  <ng-content></ng-content>
</div>